export const WATR_OPEN_AUDIT_LOG_DECLINED = 'watr-open-audit-log-declined';

export type WatrAuditLogFocusDetail = {
    token: number;
};

let focusToken = 0;

export function requestOpenAuditLogDeclined(): void {
    focusToken += 1;
    if (typeof window === 'undefined') {
        return;
    }
    window.dispatchEvent(new CustomEvent(WATR_OPEN_AUDIT_LOG_DECLINED, {
        detail: { token: focusToken } as WatrAuditLogFocusDetail
    }));
}
